import { Form, Button, Row, Col, Card } from 'antd';
import { connect } from 'react-redux';
import Utility, { notifyPlacement, notifyType } from '../../helper/utility';
import requestRepo from '../../repository/requestRepo';
import InputField from '../shared/InputField';
import PersianDatePicker from '../shared/persianDatePicker';
import RadioField from '../shared/RadioField';
import SelectField from '../shared/SelectField';
import basicInfoRepo from '../../repository/basicInfoRepo';
import React, { useEffect, useState } from 'react';
import handleRsponse from '../../helper/handleRsponse';
const RegisterService = (props) => {
    const [registerResult, setRegisterResult] = useState('');
    const [isSuccess, setIssuccess] = useState(false);
    const [isLoaded, setIsLoaded] = useState(true);
    const [productCodeList, setProductList] = useState([{ id: 1, 'title': 'پکیج' }, { id: 2, 'title': 'رادیاتور' }, { id: 3, 'title': 'آبگرمکن' }]);
    let defaultSvcTypeId = props.serviceTypeId;
    useEffect(() => { handleRsponse.handleAxios(basicInfoRepo.getList(`typeId=5&parentId=0`), fillProducts, setIsLoaded) }, []);
    const onFinish = (values) => {
        //values.CustomerTitleId=2;    
        let customer = props.currentUser;
        customer.CustomerTitleId = 2;
        customer.address = customer.lastAddress;
        handleRsponse.handleAxios(requestRepo.registerRequest({
            ...values, ...{ customer: customer }
        }, props.currentUser.token), aftersave, setIsLoaded)
    };
    const aftersave = (response) => {
        if (response.status === 200) {
            //console.log(response, 'responseData');
            if (response.data.isSuccess) {
                Utility.openNotification(notifyType.success, notifyPlacement.bottomLeft, 'موفق', 'درخواست شما با موفقیت ثبت شد');
                setIssuccess(true);
                setRegisterResult(response.data.data);
            }
            else
                Utility.openNotification(notifyType.error, notifyPlacement.bottomLeft, 'خطا', response.data.message);
        }
        else {
            if (response.status == 400) {
                Utility.openNotification(notifyType.error, notifyPlacement.bottomLeft, response.data.data.title, response.data.data.errors);
            }
        }
    }
    const fillProducts = (response) => {
        setProductList(handleRsponse.getResponse(response));
    }
    const goToRegisterAddress = () => {
        props.history.push('/registerAddress');
    }
    return <div>
        {!(isSuccess) ?
            <Card>
                <Form onFinish={onFinish} initialValues={{
                    serviceTypeId: `${defaultSvcTypeId}`,
                }}>
                    <RadioField name='serviceTypeId' label="نوع سرویس" />
                    <Row>

                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <SelectField name="ProductId" label="محصول" placeholder="محصول خود را انتخاب نمایید" list={productCodeList} />
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <PersianDatePicker name="requestdDate" label="تاریخ درخواستی" placeholder="تاریخ درخواستی " />
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <InputField name="modelNo" label="مدل" req={false} placeholder="مدل دستگاه" />
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <InputField name="serialNo" label="سریال" req={false} placeholder="سریال دستگاه" />
                        </Col>

                    </Row>
                    <Row>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <InputField name="comment" label="توضیحات" placeholder="توضیحات" inputType='TextArea' />
                        </Col>
                    </Row>
                    <br />
                    <Form.Item>

                        <Button type="primary" danger htmlType="submit" style={{ float: "left" }}>
                            ثبت رسید
                        </Button>
                        <Button type="primary" danger htmlType="button" style={{ float: "right" }} onClick={goToRegisterAddress}>
                            بازگشت
                        </Button>
                    </  Form.Item >
                </Form>
                {(!isLoaded) ? <span>منتظر بمانید...</span> : ''}
            </Card>
            :
            <center>
                <Card style={{width:'50%'}}>
                    <br />
                    <p><h1>درخواست شما با موفقیت ثبت شد</h1></p>
                    <br />
                    <p>منتظر تماس کارشناس شرکت باشید</p>
                    <p><strong>{'شماره درخواست' + registerResult}</strong></p>
                </Card>

            </center>}
    </div>
}
const mapStateToProps = state => ({
    logined: state.user.isAuthenticate,
    currentUser: state.user.currentUser,
    serviceTypeId: state.user.currentServiceTypeId,
    //currentCustomerInfo: state.user.currentCustomerInfo
});
export default connect(mapStateToProps, null)(RegisterService)